export interface IContainerApiConfig {
  endpoint?: string;
  mockEndpoint?: string;
  sandboxEndpoint?: string;
  contextRoot?: IContextRootConfig;
}

export type IContextDefinitionsConfig = { [key: string]: string };

export interface IContextRootConfig {
  defs?: IContextDefinitionsConfig;
}

export interface IContainerConfig {
  api?: IContainerApiConfig;
}

export interface IEnvironmentConfig {
  env: string;
  channel: string;
  subchannel: string;
  shortEnv: string;
}

export interface IEndpointConfig {
  path: string;
  urlBase?: EndpointUrlBaseMode;
  method?: 'GET' | 'POST';
  headers?: Record<string, any>;
  body?: Record<string, any>;
}

export const ENDPOINT_URL_BASE_MODE = {
  MY_DOMAIN: 'MY_DOMAIN',
};

export type EndpointUrlBaseMode =
  typeof ENDPOINT_URL_BASE_MODE[keyof typeof ENDPOINT_URL_BASE_MODE];
